













































import { computed, defineComponent, PropType } from '@vue/composition-api'
import Store from '@/classes/Store'
import useI18n from '@/composables/use-i18n'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
  },
  setup (props) {
    const i18n = useI18n()

    const reviewItems = computed(() => [{
      title: i18n.t('review.overall'),
      score: props.store.rating?.count ? props.store.score?.all : '-',
    }, {
      title: i18n.t('review.serviceProcess'),
      score: props.store.rating?.count ? props.store.score?.service : '-',
    }, {
      title: i18n.t('review.serviceAttitude'),
      score: props.store.rating?.count ? props.store.score?.manner : '-',
    }, {
      title: i18n.t('review.cleaning'),
      score: props.store.rating?.count ? props.store.score?.clean : '-',
    }])

    return {
      reviewItems,
    }
  },
})
